module.exports = __webpack_public_path__ + "img/20201102_193538.acaedd27.jpg";